import React, { useState, useEffect } from 'react';
import serviceManager from '../services/serviceManager';
import { useAuth } from '../contexts/AuthContext';

const ModeSwitcher = () => {
  return null;
};

export default ModeSwitcher; 